module.exports = __webpack_public_path__ + "static/media/sdhdIMG.a4c3a076.jpg";